export default __webpack_public_path__ + "static/media/dar_logo_text_dark.a0ac87f0.svg";